module.exports = {
    // basic
    'uploader': 'uploader',
    'standard': 'standard',
    'group-by-entry-type': 'group by entry type',
    'modify-files': 'modify files',
    'show-entry-history': 'show entry history',
    'send': 'send',
    'resend-email': 'resend email',
    'resend-text': 'resend text',
    'an-existing-contact': 'an existing contact to fill in their details',
    'contact-info': 'contact Info',
    'last-edited': 'last edited',
    'confirm': 'confirm',
    'entry-history': 'entry history',
    'email-text-subject': 'email / text subject',
    'doc-approval-entries': 'document approval entries',
    'more': 'more',
    'dept-or-role': 'department or role',
    'partners': 'partners',
    'auditWell': 'Audit Well',
    'administrators': 'administrators',
    'manage-contacts': 'Manage Contacts',
    'prod-data': 'production data',
    'non-prod-data': 'non-production data',
    'update-profile': 'Update Profile',
    // raw
    'resend-email-help': `Choose recipients from the list below.`,
    'resend-text-help': `Choose recipients from the list below, or add one by entering their cell number.`,
    'confirm-entry-delete': 'The following entries will be deleted:',
    'confirm-entry-not-delete': 'The following entries will not be deleted due to insufficient rights:',
    'enter-remarks': 'You must enter remarks.',
    'entry-remarks-template': 'All remarks fields must be filled out before saving this entry.',
    'entry-remarks': 'Remarks must be filled out before saving this entry.',
    'entry-file-required': 'This entry will have no files once the currently selected operations are performed.  This entry type requires the entry to have at least one file.  Cancel a file Delete, or add a new file to upload.',
    'entry-add-upload-date-help': `To upload using the current date and time, leave the <b>Date</b> field blank.<br />  Use it only if you need to backdate the entry.`,
    'entry-da-reject-lock': 'Clicking Ok will halt the approval process and lock the entry, forcing it to be re-uploaded.',
    'entry-da-reject-no-lock': `Clicking Ok will still "reject" the entry (it will remain in Document Approval Entries, etc), but it will still be open for further editing.`,
    'entry-deleted': 'This entry has been deleted.',
    'no-entry-history': 'No entry history.',
    'download-combined-pdf': 'Download Combined PDF',
    'entry-add-contact': 'Filling in this form will create a new contact.',
    'entry-incomplete': `
        This entry is incomplete because one or more files did not finish uploading.<br />
        These files are shown in red in the list of files, below, on the right-hand side.<br />
        You can complete the entry by trying the following:
        <p>
            <ol>
                <li>Reattach the file(s) shown in red.</li>
                <li>Delete the incomplete file(s) already partially uploaded.</li>
                <ol>
                    <li>Click the <b>Modify Files</b> button at the top of the file list.
                    <li>On the popup window that appears, click the <b>Delete</b> button next to the file(s) in red.</li>
                    <ul>
                        <li>You may have to close this message, first, to see the popup window.</li>
                    </ul>
                    <li>Click the <b>Ok</b> button on the popup window.
                </ol>
                <li>Check the box for <b>Preserve Upload Date</b> to preserve the entry's position on the Entries page.</li>
                <li>Click the <b>Save</b> button.</li>
                <li>Wait for the upload status bar to reach 100% and the page to refresh to the Entries page before closing your tab or browser.<br />
            </ol>
        </p>
        This will replace the incomplete file(s) in red and complete the entry.</li>
    `,
    'remarks-too-large': 'Remarks data too large.',
    'entry-contact-required': `A contact is required to upload.  Please select a contact from the list.  If no contacts exist, click <b>Add Contact</b> to add a new one.`,
    'update-profile-help': `Please update your profile with a <b>Cell Number</b> and <b>Cell Carrier.</b> This helps ensure WellDrive can contact you if there are any issues with the data.`,
    'cell-number-required': `Please enter cell number`,
    'cell-carrier-required': `Please select a cell carrier`,
    // template
    'resend-text-limit-help': (words) => `
        The remarks of this entry exceed the limit of <span class="text-danger">${words[0]}</span> characters, and will be truncated. If you wish to avoid this, please edit the entry to have fewer characters in the remarks.
    `,
    'entry-filename-length': (words) => `The filename "${words[0]}" contains ${words[1]} characters, which exceeds the limit of ${words[2]} characters.`,
    'entry-filename-length-warning': (words) => `The filename "${words[0]}" contains ${words[1]} characters, which may cause issues with some applications.`,
    'entry-filename-bad-chars': (words) => `The filename "${words[0]}" contains illegal characters.`,
    'entry-filename-whitespace': (words) => `The filename "${words[0]}" has extra spaces at the beginning and/or end.`,
    'entry-filename-exists': (words) => `A file with the name "${words[0]}" already exists.`,
    'entry-filename-exists-in-uploader': (words) => `A file with the name "${words[0]}" is already in the upload queue.`,
    'entry-filename-invalid': (words) => `The filename "${words[0]}" is invalid.`,
    'entry-edit-contact': (words) => `Any changes to this form will edit contact "${words[0]}".`,
    'entry-rejection-info': (words) => `Rejected by ${words[0]} on ${words[1]}: <br />${words[2]}`,
    'sms-limit': (words) => `This entry type allows remarks to be sent as a text message. You may enter as much as you wish, but depending on the recipient\'s ISP, the message they receive may be truncated after <b><span id="smsCharacterLimit">${words[0]}</span></b> characters. Current character number:`,
    'step-approval-info': (words) => `${words[0]} approved by ${words[1]} on ${words[2]}<br />`,
    'delete-fail': (words) => `${words[0]} delete failed.`,
    'invalid-filename': (words) => `The file "${words[0]}" has no extension (ie. .pdf, .txt, .xslx, .las, .docx), or the extension is invalid.`,
    'confirm-entry-delete-detail': (words) => `\n${words[0]}: ${words[1]}, ${words[2]}: ${words[3]}, ${words[4]}: ${words[5]}`,
    'delete-done': (words) => `${words[0]} deleted.`,

};
